import { defineStore } from "pinia";
import { ref } from "vue";

export const useNutritionBasisStore = defineStore("nutritionBasis", () => {
	const isPer100g = ref(true);

	return { isPer100g };
});
